/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestCompoundV3Comet extends Contract<ITestCompoundV3Comet> {
  allowance: Call<(_owner: AddressLike, _spender: AddressLike) => BigNumber, ITestCompoundV3Comet>
  'allowance(address,address)': Call<(_owner: AddressLike, _spender: AddressLike) => BigNumber, ITestCompoundV3Comet>
  approve: Send<(_spender: AddressLike, _amount: BigNumberish) => boolean, ITestCompoundV3Comet>
  'approve(address,uint256)': Send<(_spender: AddressLike, _amount: BigNumberish) => boolean, ITestCompoundV3Comet>
  balanceOf: Call<(_account: AddressLike) => BigNumber, ITestCompoundV3Comet>
  'balanceOf(address)': Call<(_account: AddressLike) => BigNumber, ITestCompoundV3Comet>
  baseToken: Call<() => string, ITestCompoundV3Comet>
  'baseToken()': Call<() => string, ITestCompoundV3Comet>
  decimals: Call<() => BigNumber, ITestCompoundV3Comet>
  'decimals()': Call<() => BigNumber, ITestCompoundV3Comet>
  supply: Send<(_asset: AddressLike, _amount: BigNumberish) => void, ITestCompoundV3Comet>
  'supply(address,uint256)': Send<(_asset: AddressLike, _amount: BigNumberish) => void, ITestCompoundV3Comet>
  symbol: Call<() => string, ITestCompoundV3Comet>
  'symbol()': Call<() => string, ITestCompoundV3Comet>
  totalSupply: Call<() => BigNumber, ITestCompoundV3Comet>
  'totalSupply()': Call<() => BigNumber, ITestCompoundV3Comet>
  transfer: Send<(_recipient: AddressLike, _amount: BigNumberish) => boolean, ITestCompoundV3Comet>
  'transfer(address,uint256)': Send<(_recipient: AddressLike, _amount: BigNumberish) => boolean, ITestCompoundV3Comet>
  transferFrom: Send<(_sender: AddressLike, _recipient: AddressLike, _amount: BigNumberish) => boolean, ITestCompoundV3Comet>
  'transferFrom(address,address,uint256)': Send<(_sender: AddressLike, _recipient: AddressLike, _amount: BigNumberish) => boolean, ITestCompoundV3Comet>
  withdraw: Send<(_asset: AddressLike, _amount: BigNumberish) => void, ITestCompoundV3Comet>
  'withdraw(address,uint256)': Send<(_asset: AddressLike, _amount: BigNumberish) => void, ITestCompoundV3Comet>
}

let ITestCompoundV3CometBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestCompoundV3CometBytecode = '0x';
}

// prettier-ignore
export const ITestCompoundV3Comet = contract<ITestCompoundV3Comet>(ITestCompoundV3CometBytecode)`
  event Approval(address indexed owner, address indexed spender, uint256 value)
  event Transfer(address indexed from, address indexed to, uint256 value)
  function allowance(address _owner, address _spender) view returns (uint256 amount_)
  function approve(address _spender, uint256 _amount) returns (bool success_)
  function balanceOf(address _account) view returns (uint256 balance_)
  function baseToken() view returns (address baseToken_)
  function decimals() view returns (uint8 decimals_)
  function supply(address _asset, uint256 _amount)
  function symbol() view returns (string symbol_)
  function totalSupply() view returns (uint256 supply_)
  function transfer(address _recipient, uint256 _amount) returns (bool success_)
  function transferFrom(address _sender, address _recipient, uint256 _amount) returns (bool success_)
  function withdraw(address _asset, uint256 _amount)
`;